import { createInertiaApp } from '@inertiajs/react'
import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import RootLayout from '@/components/root_layout';
import TeamLayout from '@/components/team_layout';

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  title: (title) => title ? `${title} — bookd.one` : 'bookd.one',

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.jsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.jsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.jsx'`)
    }

    // To use a default layout, import the Layout component
    // and use the following lines.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    // page.default.layout ||= (page) => (<Layout>{page}</Layout>)

    page.default.layout = name.startsWith('team/') ? (page) => <TeamLayout children={page} /> : <RootLayout children={page} />;

    return page
  },

  setup({ el, App, props }) {
    const app = (
      <StrictMode>
        <App {...props} />
      </StrictMode>
    )
    const ssrContent = Array.from(el.childNodes).some(
      (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'SCRIPT'
    )
    if (ssrContent) {
      hydrateRoot(el, app)
    } else {
      createRoot(el).render(app)
    }
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
    },
    future: {
      useScriptElementForInitialPage: true,
      useDataInertiaHeadAttribute: true,
      useDialogForErrorModal: true,
      preserveEqualProps: true,
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_javascript_tag "inertia.jsx" %> to the Inertia-specific layout instead.',
    )
  }
})
